<div class="card">
    <div class="message-header">HELP & SUPPORT</div>
    <p-divider></p-divider>
    <div></div>
    <div class="p-grid">
        <div class="p-col-12"><strong>Call: </strong>+1 (212)-405-2500</div>
        <div class="p-col-12"><strong>Email: </strong><a class="hyperLink" href="mailto:help@naiglobal.com">help@naiglobal.com</a></div>
        <div class="p-col-12"><a class="hyperLink" (click)="NavToFAQs()">Frequently-Asked Questions</a></div>        
    </div>
</div>
